
import en from './en/messages.json'
import zhCn from './zh-cn/messages.json'
import ptBr from './pt-br/messages.json'

export default {
  en,
  'zh-CN': zhCn,
  'zh-cn': zhCn,
  'pt-br': ptBr
}